// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"toast_disable-scroll__37KPw"};